module.exports = __webpack_public_path__ + "static/media/marque-parcoursgagnant.b8b02668.glb";